export default "__VITE_ASSET__CvSIo1Zu__"